import { memo } from 'react'

import cl from './CompanyDescription.module.scss'

export type CompanyDescriptionProps = {
	description: string
}

export const CompanyDescription = memo(
	({ description }: CompanyDescriptionProps): JSX.Element => (
		<section className={cl.section}>
			<p className={cl.text}>{description}</p>
		</section>
	)
)
